module.exports = __webpack_public_path__ + "img/L-B.14120925.png";